// src/components/NotFound.js
import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <a href="/">Take me back</a>
    </div>
  );
};

export default NotFound;
